import { render } from "./ChallengeChain.vue?vue&type=template&id=483dc9f4&scoped=true"
import script from "./ChallengeChain.vue?vue&type=script&lang=js"
export * from "./ChallengeChain.vue?vue&type=script&lang=js"

import "./ChallengeChain.vue?vue&type=style&index=0&id=483dc9f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483dc9f4"]])

export default __exports__